export const mairAggregatesDummyData = {
  aiAnsweredCalls: 2000,
  aiEngagedCalls: 1750,
  appointmentsScheduled: 160,
  appointmentsSchedulingAction: 128,
  appointmentsReschedulingAction: 32,
  unscheduledSchedulingOpportunities: 400,
  recoveredSchedulingOpportunities: 40,
  aiThreads: 1680,
  aiInteractedThreads: 1580,
  pendingThreads: 4,
};
